import * as React from 'react';
import MatchesApi from "../../api/Matches";
import * as moment from 'moment';
import LeaguesApi from "../../api/Leagues";
import TeamsApi from "../../api/Teams";
import PlayersApi from "../../api/Players";
import Player_MatchApi from "../../api/Player_Match";
import CompanyApi from "../../api/Company";
import { toast } from "react-toastify";
import { apiUrl, imgUrl } from '../../constants';
import "./matchpdf.css";
import CourtsApi from '../../api/Courts';
import RefereesApi from '../../api/Referees';

export default class MatchPdf extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            match: {},
            league: {},
            team1: {},
            team2: {},
            team1_players: [],
            team2_players: [],
            players_stats: [],
            court: [],
            referee: [],
            company: {}
        };
    }

    componentWillMount(){
        let state = {...this.state};
        MatchesApi.get(this.props.match.params.value).then(r => {
            state.match = r.data.response;
            return LeaguesApi.get(state.match.league_id);
        }).then(r => {
            state.league = r.data.response;
            return TeamsApi.get(state.match.team1_id);
        }).then(r => {
            state.team1 = r.data.response;
            return TeamsApi.get(state.match.team2_id);
        }).then(r => {
            state.team2 = r.data.response;
            return CompanyApi.get(localStorage.getItem("id"));
        }).then(r =>{
            if(r.data.response.length>0){
                state.company = r.data.response[0];
            }else state.company = {};
            return PlayersApi.getByTeam(state.team1.id);
        }).then(r =>{
            state.team1_players = r.data.response;
            return PlayersApi.getByTeam(state.team2.id);
        }).then(r =>{
            state.team2_players = r.data.response;
            return CourtsApi.get(state.match.court_id);
        }).then(r =>{
            state.court = r.data.response;
            return RefereesApi.get(state.match.referee_id);
        }).then(r =>{
            state.referee = r.data.response;
            this.setState(state);
        }).catch(err => console.log(err));
            // return Player_MatchApi.getByMatch(state.match.id);
        // }).then(r => {
        //     state.players_stats = r.data.response;
        //     return PlayersApi.getByTeam(state.match.team1_id);
        // }).then(r => {
        //     state.team1_players = r.data.response;
        //     state.team1_players.forEach(p => {
        //         let stats = state.players_stats.find(s => s.player_id === p.id);
        //         p.gp = stats ? stats.played === "1" : false;
        //         p.bc = stats ? stats.bc : 0;
        //         p.rc = stats ? stats.rc : 0;
        //         p.yc = stats ? stats.yc : 0;
        //         p.goals = stats ? stats.goals : 0;
        //     });
        //     return PlayersApi.getByTeam(state.match.team2_id);
        // }).then(r => {
        //     state.team2_players = r.data.response;
        //     state.team2_players.forEach(p => {
        //         let stats = state.players_stats.find(s => s.player_id === p.id);
        //         p.gp = stats ? stats.played === "1" :  false;
        //         p.bc = stats ? stats.bc : 0;
        //         p.rc = stats ? stats.rc : 0;
        //         p.yc = stats ? stats.yc : 0;
        //         p.goals = stats ? stats.goals : 0;
        //     });
    }

    // componentDidUpdate(){
    //     this.printElem("printArea");
    // }

    printElem(divId) {
        var content = document.getElementById(divId).innerHTML;
        var mywindow = window.open('', 'Print');
    
        mywindow.document.write('<html><head><title>Print</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write(content);
        mywindow.document.write('</body></html>');
    
        mywindow.document.close();
        mywindow.focus()
        mywindow.print();
        mywindow.close();
        return true;
    }

    print(){
        this.printElem("printArea");
    }

    render(){
        console.log(this.state)
        return (
            <div>
                <button onClick={()=>this.print()}>Imprimir</button>
                <div id="printArea">
                    <div className="card">
                        <div className="card-content">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="is3">
                                            <b>Categoría: </b><br/>
                                            <label>{this.state.match.league1}</label>
                                        </td>
                                        <td className="is3">
                                            <b>{this.state.company.name}</b><br/>
                                            <label>{this.state.company.address}</label>
                                        </td>
                                        <td className="is4">
                                            <img src={imgUrl+this.state.company.logo} height="150px" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="is5">
                                            <b>Arbitro: </b>
                                            <label>{this.state.referee.name}</label>
                                        </td>
                                        <td className="is5">
                                            <b>Cancha:</b>
                                            <label>{this.state.court.name}</label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/matches/MatchPdf.js